module.exports = __webpack_public_path__ + "media/images/Cafod-Logo-e642054f1ae5ed74c7ca53f4a3d04307.jpg";